const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000" // 🖥️ Desarrollo local
    : process.env.REACT_APP_BACKEND_URL || "https://backend-vp5e.onrender.com"; // 🌍 Producción

export default API_URL;
